import Vue from "vue";
import Router from "vue-router";
import HelloWorld from "@/components/HelloWorld";
import Order from "@/components/Order";
import Contact from "@/components/Contact";
import About from "@/components/About";
import Goods from "@/components/Goods";
import Details from "@/components/Details";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "HelloWorld",
      component: HelloWorld,
      children: [
        {
          path: "/",
          name: "order",
          component: Order,
        },
        {
          path: "/contact",
          name: "contact",
          component: Contact,
        },
        {
          path: "/about",
          name: "about",
          component: About,
        },
        {
          path: "/goods",
          name: "goods",
          component: Goods,
        },
        {
          path: "/details",
          name: "details",
          component: Details,
        },
      ],
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js